// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2_DXh","savePackageButton":"ClientWallet_savePackageButton__3B8Cr"};